export default __webpack_public_path__ + "static/media/logo-02.3d84c4f4.svg";